import { AppThunk } from '../../../store/rootReducer';
import { ecgIdSelector } from '../../ecg/selectors/ecg.selectors';
import * as waveActions from '../../wave/actions/wave.actions';
import { processWaves } from '../../wave/thunks/prepare-waves.thunk';
import * as delineationClient from '../clients/delineation.client';
import { delineationByIdSelector } from '../selectors/delineation.selectors';
import { DelineationId } from '../types/delineation.type';
import { isServerDelineationId } from '../utils/delineation.utils';
import * as delineationActions from '../actions/delineation.actions';

export const loadDelineationWaves =
  (delineationId: DelineationId): AppThunk =>
  async (dispatch, getState) => {
    const ecgId = ecgIdSelector(getState());
    const delineation = delineationByIdSelector(delineationId)(getState());

    if (ecgId == null || delineation == null) {
      return;
    }

    let delineationWaves = delineation.waves;
    if (delineationWaves == null) {
      delineationWaves = [];

      if (isServerDelineationId(delineationId)) {
        delineationWaves = await delineationClient.getDelineation(
          ecgId,
          delineationId,
        );
      }
    }

    const processedWaves = dispatch(processWaves(delineationWaves));
    dispatch(waveActions.setWaves({ waves: processedWaves }));
    dispatch(
      delineationActions.setWaves({
        delineationId,
        waves: processedWaves,
        meta: { history: false },
      }),
    );
  };
